<script setup>
import { useToggle } from '@vueuse/core';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const [isOpen, toggle] = useToggle(props.defaultOpen);
</script>

<template>
  <section
    v-bind="$attrs"
    class="w-full overflow-hidden rounded-2xl border border-n-weak bg-n-alpha-1 shadow-sm"
  >
    <button
      type="button"
      class="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left hover:bg-n-alpha-2 sm:px-6"
      :aria-expanded="isOpen"
      @click="toggle()"
    >
      <span class="text-heading-3 text-n-slate-12">
        {{ title }}
      </span>
      <span
        class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-n-alpha-2 text-lg text-n-slate-11 transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        aria-hidden="true"
      >
        <Icon icon="i-lucide-chevron-down" class="size-4" />
      </span>
    </button>
    <div
      v-if="isOpen"
      class="w-full space-y-4 border-t border-n-weak bg-n-background px-5 py-5 sm:px-6"
    >
      <slot />
    </div>
  </section>
</template>
